export default "__VITE_ASSET__Cqp3Z$go__"